// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubCategorySkeleton-subCategorySkeletonListContainer-yR2Eu {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    grid-gap: 24px;
    margin-top: 24px;
}

.SubCategorySkeleton-subCategorySkeletonListItem-AI_4E {
    background: var(--background-primary);
    border-radius: var(--radius-3);
    padding: 12px;
}

.SubCategorySkeleton-subCategorySkeletonListItemImg-Dl5PQ {
    position: relative;
    width: 100%;
    height: 148px;
    border-radius: 0 var(--radius-2) 0 var(--radius-2);
}

.SubCategorySkeleton-subCategorySkeletonListItemInfoContainer-fnpUI {
    margin-top: 12px;
}

.SubCategorySkeleton-subCategorySkeletonTitle-rE_W2 {
    max-width: 92px;
    height: 26px;
    border-radius: var(--radius-5);
    margin-bottom: 2px;
}

.SubCategorySkeleton-subCategorySkeletonDesc-EKfvM {
    max-width: 79px;
    height: 24px;
    border-radius: var(--radius-5);
    margin-bottom: 3px;
}

.SubCategorySkeleton-subCategorySkeletonLarge-tdjfg {
    max-width: 128px;
    height: 26px;
    border-radius: var(--radius-5);
    margin-bottom: 12px;
}

.SubCategorySkeleton-subCategorySkeletonButton-YKKlc {
    max-width: 1005;
    height: 44px;
    border-radius: var(--radius-5);
}

@media (max-width: 1199px) and (min-width: 576px) {
    .SubCategorySkeleton-subCategorySkeletonListContainer-yR2Eu {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 575px) {
    .SubCategorySkeleton-subCategorySkeletonListContainer-yR2Eu {
        grid-template-columns: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/Categories/SubCategorySkeleton/SubCategorySkeleton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".subCategorySkeletonListContainer {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n    grid-gap: 24px;\n    margin-top: 24px;\n}\n\n.subCategorySkeletonListItem {\n    background: var(--background-primary);\n    border-radius: var(--radius-3);\n    padding: 12px;\n}\n\n.subCategorySkeletonListItemImg {\n    position: relative;\n    width: 100%;\n    height: 148px;\n    border-radius: 0 var(--radius-2) 0 var(--radius-2);\n}\n\n.subCategorySkeletonListItemInfoContainer {\n    margin-top: 12px;\n}\n\n.subCategorySkeletonTitle {\n    max-width: 92px;\n    height: 26px;\n    border-radius: var(--radius-5);\n    margin-bottom: 2px;\n}\n\n.subCategorySkeletonDesc {\n    max-width: 79px;\n    height: 24px;\n    border-radius: var(--radius-5);\n    margin-bottom: 3px;\n}\n\n.subCategorySkeletonLarge {\n    max-width: 128px;\n    height: 26px;\n    border-radius: var(--radius-5);\n    margin-bottom: 12px;\n}\n\n.subCategorySkeletonButton {\n    max-width: 1005;\n    height: 44px;\n    border-radius: var(--radius-5);\n}\n\n@media (max-width: 1199px) and (min-width: 576px) {\n    .subCategorySkeletonListContainer {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 575px) {\n    .subCategorySkeletonListContainer {\n        grid-template-columns: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subCategorySkeletonListContainer": `SubCategorySkeleton-subCategorySkeletonListContainer-yR2Eu`,
	"subCategorySkeletonListItem": `SubCategorySkeleton-subCategorySkeletonListItem-AI_4E`,
	"subCategorySkeletonListItemImg": `SubCategorySkeleton-subCategorySkeletonListItemImg-Dl5PQ`,
	"subCategorySkeletonListItemInfoContainer": `SubCategorySkeleton-subCategorySkeletonListItemInfoContainer-fnpUI`,
	"subCategorySkeletonTitle": `SubCategorySkeleton-subCategorySkeletonTitle-rE_W2`,
	"subCategorySkeletonDesc": `SubCategorySkeleton-subCategorySkeletonDesc-EKfvM`,
	"subCategorySkeletonLarge": `SubCategorySkeleton-subCategorySkeletonLarge-tdjfg`,
	"subCategorySkeletonButton": `SubCategorySkeleton-subCategorySkeletonButton-YKKlc`
};
module.exports = ___CSS_LOADER_EXPORT___;
